import { Component } from '@angular/core';
import { SearchService, SearchCriteria } from '../../common/services/search.service';
import { Store } from '@ngrx/store';
import { UPDATESTATE } from '../reducers/search-state';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { GaService } from '../../common/services/ga.service';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent {
  // Search
  public emptySearch: boolean = false;
  public haveResults: boolean = false;
  searchMapCollapsed: boolean = false;
  showingMap: boolean = false;
  public tableauJWT: string;

  mySearchResults$

  // Filters
  public filtersForResults = ['All Items', 'Hospitals', 'Systems', 'People'];

  //Facets/State Search
  stateSearchOpen: boolean = false;

  // Add Spinner if Searching on Filter
  searchingWithFilter = false;

  // vars from Store
  public stateSelected = '';
  public stateSelectedAbbr = '';
  searchStateObj;
  searchResult;
  constructor(
    private store: Store<any>,
    private searchService: SearchService,
    private route: ActivatedRoute,
    private gaService: GaService,
  ) {
    store.select('searchState').subscribe((searchState: SearchCriteria) => {
      this.searchResult = searchState['result'];
      this.stateSelected = searchState['state'];
      this.stateSelectedAbbr = searchState['stateSelectedAbbr'];
      this.searchStateObj = searchState;

      if (!_.isEmpty(this.searchStateObj.result)) {
        this.haveResults = true;
        this.emptySearch = false;
      } else {
        this.emptySearch = true;
      }
    });

    this.mySearchResults$ = store.select('searchState');

    // If query parameter exists, perform search using passed value,
    // translating decoded + to spaces.
    this.route.queryParams.subscribe(
      params => {
        if (params.query) {
          this.searchOnQueryParams(decodeURI(params.query.replace(/\+/g, ' ')))
        }
      }
    )
  }

  searchOnQueryParams(querySearchTerm) {
    this.store.dispatch({
      type: UPDATESTATE,
      payload: Object.assign({}, this.searchStateObj, {
        searchTerm: querySearchTerm
      })
    })
    this.search()
  }

  searchingOnFilter(event) {
    if (event === 'searchingOnFilter') {
      this.searchingWithFilter = true;
    } else {
      this.searchingWithFilter = false;
    }
  }

  toggleStateSearch() {
    this.stateSearchOpen = !this.stateSearchOpen;
  }

  toggleMap() {
    this.showingMap = !this.showingMap;
  }

  pageChanged(event: any): void {
    this.searchStateObj.pageNum = event.page;

    if (this.stateSelected) {
      this.advanceSearchOn();
    } else {
      this.search();
    }
  }

  search() {
    this.searchService
      .advancedSearch({
        searchTerm: this.searchStateObj.searchTerm,
        searchType: this.searchStateObj.searchBy,
        pageNum: this.searchStateObj.pageNum
      })
      .subscribe(({ data }) => {
        this.searchingWithFilter = false;
        this.store.dispatch({
          type: UPDATESTATE,
          payload: Object.assign({}, this.searchStateObj, {
            total: data.search.total,
            result: data.search.result
          })
        });
      });
    //google analytics
    this.gaService.addSearch(this.searchStateObj.searchTerm);
  }

  advanceSearchOn() {
    let citiesSelected = _.filter(this.searchStateObj.cities, function (o) {
      return o.selected;
    }).map(x => x.name);
    let countiesSelected = _.filter(this.searchStateObj.counties, function (o) {
      return o.selected;
    }).map(x => x.name);

    let searchCriteria = {
      state: this.stateSelectedAbbr,
      searchTerm: this.searchStateObj.searchTerm,
      searchType: this.searchStateObj.searchBy,
      cities: citiesSelected,
      counties: countiesSelected,
      pageNum: this.searchStateObj.pageNum
    };

    this.searchService.advancedSearch(searchCriteria).subscribe(({ data }) => {
      this.searchingWithFilter = false;
      this.store.dispatch({
        type: UPDATESTATE,
        payload: Object.assign({}, this.searchStateObj, {
          total: data.search.total,
          result: data.search.result
        })
      });
    });

    //google analytics
    this.gaService.addAdvancedSearch(
      'advanced',
      this.searchStateObj.searchTerm,
      this.searchStateObj.state,
      citiesSelected,
      countiesSelected
    );
  }

  toggle(event) {
    event.preventDefault();
    this.searchStateObj.filterResultsBy = event.target.innerHTML;

    switch (this.searchStateObj.filterResultsBy) {
      case 'All Items':
        this.searchStateObj.filterResultsBy = 'All Items';
        this.searchStateObj.searchBy = 'all';
        this.searchStateObj.typeaheadSuggest = 'allSuggest';
        break;
      case 'Hospitals':
        this.searchStateObj.filterResultsBy = 'Hospitals';
        this.searchStateObj.searchBy = 'hospital';
        this.searchStateObj.typeaheadSuggest = 'hospitalSuggest';
        break;
      case 'Systems':
        this.searchStateObj.filterResultsBy = 'Systems';
        this.searchStateObj.searchBy = 'system';
        this.searchStateObj.typeaheadSuggest = 'systemSuggest';
        break;
      case 'People':
        this.searchStateObj.filterResultsBy = 'People';
        this.searchStateObj.searchBy = 'person';
        this.searchStateObj.typeaheadSuggest = 'personSuggest';
        break;
      default:
        this.searchStateObj.filterResultsBy = 'All Items';
        this.searchStateObj.searchBy = 'all';
        this.searchStateObj.typeaheadSuggest = 'allSuggest';
    }
    //google analytics
    this.gaService.addNavigationClick(this.searchStateObj.filterResultsBy);

    this.searchingWithFilter = true;
    if (this.stateSelected) {
      this.advanceSearchOn();
    } else {
      this.search();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/search/search/search.component.ts